import { useState } from 'react'

type WizardMode = 'add-pronunciation' | 'verify-term'

export interface ContextData {
  audio: {
    url: string | null
    path: string | null
  }
}

interface WizardState {
  open: boolean
  mode: WizardMode
  contextData: ContextData | null
}

export default function useRepeatAudioWizard() {
  const [wizardState, setWizardState] = useState<WizardState>({
    open: false,
    mode: 'add-pronunciation',
    contextData: null,
  })

  const showWizard = (mode: WizardMode = 'add-pronunciation', contextData: ContextData | null = null) => {
    setWizardState({
      open: true,
      mode,
      contextData,
    })
  }

  return {
    wizardOpen: wizardState.open,
    wizardMode: wizardState.mode,
    wizardContext: wizardState.contextData,
    showWizard,
    handleWizardClose: () => {
      setWizardState(prev => ({ ...prev, open: false }))
    },
  }
}
